export interface Series {
  repeat_frequency: string
}

export interface Task {
  id: number
  state: string
  optional: boolean
}

export interface JobItem {
  start_date_time: string | null
  end_date_time: string | null
  date_completed: string | null
  series: Series | null
  overdue: boolean
  state: string
  id?: number
  title?: string
  tasks: Task[]
  site: Site
}

export interface Site {
  id: number
  name: string
  timezone?: string
  siteGroups?: Array<number>
}

export type FormatMessage = (message: string | { id: string }) => string

export interface User {
  avatar?: string
  id: number
  name: string
  type?: string
  assigneeType?: string
}

export interface UserGroup {
  id: number
  name: string
  avatar?: string
  assigneeType?: string
}

export interface Licensee {
  usaDateFormat: boolean
  usaTimeFormat: boolean
  mobileJobSyncDaysPast?: number
  mobileJobSyncDaysAhead?: number
}

export interface Action {
  type: string
  payload: unknown
  promise: unknown
}

export interface Profile {
  id: number
  jobsManagementFilters: {
    [key: string]: unknown
  }
  name: string
  licensee: Licensee
  signatureUrl: string
  signatureDataUrl: string
}

export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export interface PsfsType {
  path: string
  _filters: {
    getFiltersQuery: () => string
  } | null
  _pagination: {
    getPagination: () => {
      limit: number
      page: number
    }
    clearPagination: () => void
  } | null
  _sort: {
    getSort: () => {
      field: string | null
      order: SORT_DIRECTION
    }
  } | null
  addFilter: (name: string, data: unknown, type?: string) => void
  clearFilter: (name: string) => void
}

export interface Workflow {
  id: number
  title: string
  automatic_due_date: boolean
  automatic_due_date_days: number
  automatic_due_date_time: string
}

export interface Unit {
  id: number
  containerName: string
}

export interface UnitGroup {
  id: number
  name: string
}

export interface UnitInsideTree {
  id: number
  name: string
}

export interface UnitTree {
  id: number
  name: string
  locuses: UnitInsideTree[]
}
